import * as React from "react"
import {useTheme} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core"

import {MENU_SIZE} from "../../../../@constants"
import {menuSize} from "../../../../@signals";
import {MENU_SIZE_KEY} from "../../../../@signals/app";
import {useApp} from "../../../../@hooks";
import {MaximalLayoutNavToggleButtonStyles} from "./styles";


export default function MaximalLayoutNavToggleButton() {
    const theme = useTheme()
    const { isMini } = useApp()

    return <ButtonIconSeeker
        size="small"
        icon={isMini ? 'angle-right' : 'angle-left'}
        sx={MaximalLayoutNavToggleButtonStyles(theme, isMini)}
        onClick={() => {
            menuSize.value = menuSize.value === MENU_SIZE.EXTENDED ? MENU_SIZE.MINI : MENU_SIZE.EXTENDED
            localStorage.setItem(MENU_SIZE_KEY, menuSize.value)
        }}
    />
}